import EscapedAnimal from './EscapedAnimal';
import EscapedAnimalIntro from './EscapedAnimalIntro';
import EscapedAnimalOutro from './EscapedAnimalOutro';

export default [EscapedAnimalIntro, EscapedAnimal, EscapedAnimalOutro];
